import * as React from "react";
import type { SVGProps } from "react";

const FacilityMuseum = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M10.0019 6.01576C9.97438 6.01575 9.94796 6.02676 9.92855 6.04633C9.90914 6.0659 9.89835 6.0924 9.89857 6.11997C9.89857 6.17752 9.94523 6.22418 10.0028 6.22418C10.0603 6.22418 10.107 6.17752 10.107 6.11997C10.1061 6.06247 10.0595 6.0162 10.0019 6.01576"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4818 8.61075H2.52221C2.40555 8.61097 2.29358 8.56478 2.21101 8.48236C2.12843 8.39995 2.08203 8.28807 2.08203 8.1714V6.52405C2.0823 6.16537 2.31197 5.84706 2.65227 5.73372L9.72355 3.37607C9.90433 3.31605 10.0997 3.31605 10.2804 3.37607L17.3517 5.73372C17.692 5.84706 17.9217 6.16537 17.922 6.52405V8.1714C17.922 8.28807 17.8756 8.39995 17.793 8.48236C17.7104 8.56478 17.5984 8.61097 17.4818 8.61075Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.3309 15.0022V8.61035"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6707 8.61035V15.0022"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66684 8.61035V15.0022"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99887 8.61035V15.0022"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3348 8.61035V15.0022"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9888 15.002H3.01296C2.69727 15.0021 2.40876 15.1806 2.26765 15.463L1.75243 16.4934C1.69425 16.609 1.66406 16.7366 1.66406 16.8661V17.503H18.3377V16.8661C18.3377 16.7366 18.3075 16.609 18.2493 16.4934L17.7341 15.463C17.593 15.1806 17.3045 15.0021 16.9888 15.002Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1691 17.5038H0.828125"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityMuseum.displayName = "FacilityMuseum";

export default FacilityMuseum;
